<template>
  <v-container class="ma-0 pa-0">
    <v-row class="mt-2">
      <v-col cols="8" class="py-0 d-flex justify-start">
        <p class="pa-2 mb-0 mensajeIzq">
          {{ respuestas.motivo }}
          <br>
          <span style="font-size: small;" class="d-flex justify-end">{{ respuestas.fecha }}</span>
        </p>
      </v-col>
    </v-row>
    <v-row v-if="respuestas.evidencias.length">
      <v-col cols="3" v-for="(img, i) in respuestas.evidencias" :key="i">
        <v-card
          class="py-2 shadowCard evidencia-card"
          @click="verImagen(img, i)"
          @contextmenu.prevent="descargarEvidencia(img)"
        >
          <EvidenciaMini
            :src="urlImagen(img) + img.foto"
            :video="!!img.video"
            :pdf="!!img.pdf"
            :nombre="img.foto"
            :aspect-ratio="1"
          />
        </v-card>
      </v-col>
    </v-row>

    <Imagen
      @close="closeImagen"
      :respuestaImagen="respuestaImagen"
      :isOpen="dialogImagen"
      :imagen="imagen"
      :imagenes="evidenciasActuales"
      :indiceInicial="indiceInicial"
      :ticket="ticket"
    />
  </v-container>
</template>
<script>
  import axios from 'axios'
  import Imagen from '@/components/tickets/Imagen.vue'
  import EvidenciaMini from '@/components/tickets/EvidenciaMini.vue'
  import { getEvidenciaBaseUrl, descargarEvidencia } from '@/utils/ticketEvidencias'

  export default {
    props: [
      'ticket',
      'respuestas'
    ],
    components: {
      Imagen,
      EvidenciaMini,
    },
    data: () => ({
      url: '',
      dialogImagen: false,
      respuestaImagen: false,
      imagen: '',
      evidenciasActuales: [],
      indiceInicial: 0,
    }),
    created () {
      this.url = axios.defaults.baseURL + 'evidencia-tickets/'
    },
    methods: {
      urlImagen(img) {
        return getEvidenciaBaseUrl(this.ticket, img.es_solucion)
      },
      verImagen(img, indice) {
        this.imagen = img.foto
        this.respuestaImagen = img.es_solucion
        this.evidenciasActuales = this.respuestas.evidencias
        this.indiceInicial = indice
        this.dialogImagen = true
      },
      closeImagen() {
        this.dialogImagen = false
      },
      descargarEvidencia(img) {
        descargarEvidencia(this.ticket, img.foto, img.es_solucion)
      },
    },
  }
</script>
<style>
  .mensajeIzq{
    white-space: pre-line;
    background-color: rgb(238, 235, 235);
    border-radius: 0px 10px 10px 10px;
  }
  .mensajeDer{
    white-space: pre-line;
    background-color: rgb(193, 231, 243);
    border-radius: 10px 0px 10px 10px;
  }
  .evidencia-card {
    cursor: pointer;
  }
</style>
